/**
 * E.164 US/NANP pattern: `+1` followed by exactly 10 digits.
 * Group 1 captures the 10 national digits (used for display formatting).
 * Shared so validation and formatting can never drift apart.
 */
export const E164_US_PATTERN = /^\+1(\d{10})$/;

/** True when `value` (after trimming) is a valid E.164 US number (`+1` + 10 digits). */
export function isValidE164Us(value: string): boolean {
  return E164_US_PATTERN.test(value.trim());
}

/**
 * Formats a NANP number in E.164 (+1XXXXXXXXXX) for US display:
 * +1 (XXX) XXX-XXXX
 *
 * If the value does not match, returns the trimmed input unchanged.
 */
export function formatE164UsDisplay(e164: string): string {
  const normalized = e164.trim().replace(/\s/g, '');
  const m = normalized.match(E164_US_PATTERN);
  if (!m) {
    return e164.trim();
  }
  const d = m[1];
  return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
